import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import Carousel from './carousel'

class CarouselPlayButton extends BaseComponent {
  button: Nullable<HTMLElement>

  constructor() {
    super()

    this.button = this.querySelector('[data-carousel-play-button]')
  }

  connectedCallback(): void {
    this.updatePlayState()

    if (this.button) {
      this.button.addEventListener('click', this.handleButtonClick)
    }

    if (this.carousel) {
      customElements.upgrade(this.carousel) // https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/upgrade
      customElements.whenDefined('carousel-component').then(() => {
        this.carousel.subscribe(
          'forceChangePlayState',
          this.handleCarouselChangePlayState,
        )
      })
    }
  }

  disconnectedCallback(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.handleButtonClick)
    }

    if (this.carousel) {
      customElements.whenDefined('carousel-component').then(() => {
        this.carousel.unsubscribe(
          'forceChangePlayState',
          this.handleCarouselChangePlayState,
        )
      })
    }
  }

  handleCarouselChangePlayState = (): void => {
    this.updatePlayState()
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.stopPropagation()

    if (!this.carousel) {
      return
    }

    const isForceStopped = this.carousel.isForceStopped

    if (isForceStopped) {
      this.carousel.forcePlay()
    } else {
      this.carousel.forceStop()
    }
  }

  updatePlayState(): void {
    if (!this.carousel || !this.button) {
      return
    }

    const isForceStopped = this.carousel.isForceStopped

    this.button.setAttribute(
      'data-autoplay-stopped',
      isForceStopped ? 'true' : 'false',
    )
  }

  get carousel() {
    return this.closest<Carousel>('carousel-component')
  }
}

export default CarouselPlayButton
